export default function WaveBottom() {
  return (
    <div className="wave-svg wave-bottom">
      <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <path fill="#ecc9ab" d="M0,80 C480,0 960,80 1440,0 L1440,80 L0,80 Z" />
      </svg>
    </div>
  );
}
